import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import { NaviTableBodyCellValueProps } from '../../interfaces';

const NaviTableBodyCellValue = (props: NaviTableBodyCellValueProps) => {
  const { isCellValueString, cellValue, className } = props;
  return isCellValueString ? (
    <Typography
      variant="p3"
      color="var(--grayscale-2)"
      className={cx(
        { className },
        {
          truncate: isCellValueString
        }
      )}
    >
      {cellValue}
    </Typography>
  ) : (
    cellValue
  );
};

export default NaviTableBodyCellValue;
